const testimonialRequests = [
	{
		path: '/agency/testimonial-requests/list',
		name: 'agency-testimonial-requests-list',
		component: () => import('@/views/agency/testimonial-requests/list.vue'),
		meta: {
			layout: 'content',
			module: 'MGAG,marketing',
		},
	},
]

export default testimonialRequests
